<!-- Ususally setting the title of the modal is enough, but you can use this
header if you need more control.
Just remove the title of the modal and use this in your layout.
-->

<script setup lang="ts">
import IconButton from '../IconButton/IconButton.vue';
import type { ModalResult } from './modal-store';

const props = defineProps<{
  // "any" is correct here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolve: (result: ModalResult<any>) => void;
}>();
</script>

<template>
  <div class="flex pb-4">
    <div class="flex flex-1 items-center">
      <slot />
    </div>
    <IconButton
      variant="ghost-neutral"
      icon="cancel"
      @click="
        props.resolve({
          cancelled: true,
          value: undefined,
        })
      "
    />
  </div>
</template>
